export const getActiveDropdown = data =>
  Object.keys(data)
    .find(dropdownName => data[dropdownName].active)

